'use client';

import type { CSSProperties } from 'react';
import { useMarketingBannerOffset } from 'components/shared/Header/MarketingBanner';
import { howItWorksAsset } from './asset';
import styles from './Hero.module.css';

const heroLeft = howItWorksAsset('web_v2/how-it-works/hero/left.png');
const heroCenter = howItWorksAsset('web_v2/how-it-works/hero/center.png');
const heroRight = howItWorksAsset('web_v2/how-it-works/hero/right.png');
const heroMobile = howItWorksAsset(
  'web_v2/how-it-works/hero/hero-banner-mobile-v3.png',
);

/** Stands in for the side tiles below 992px, where they are hidden and would still download. */
const BLANK = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

function SideTile({ src }: { src: string }) {
  return (
    <picture className={styles.tilePicture}>
      <source media="(max-width: 991px)" srcSet={BLANK} />
      <img className={`${styles.tile} ${styles.tileSide}`} src={src} alt="" />
    </picture>
  );
}

export function Hero({ title }: { title: string }) {
  const bannerPx = useMarketingBannerOffset();

  return (
    <section
      className={styles.section}
      style={{ '--campaign-banner-px': `${bannerPx}px` } as CSSProperties}
      aria-labelledby="how-it-works-hero-title"
    >
      <div className={styles.tiles} aria-hidden="true">
        <SideTile src={heroLeft} />
        <SideTile src={heroCenter} />
        <picture className={styles.tilePicture}>
          <source media="(max-width: 991px)" srcSet={heroMobile} />
          <img className={styles.tile} src={heroRight} alt="" />
        </picture>
      </div>
      <h1
        id="how-it-works-hero-title"
        className={styles.title}
        data-hiw-reveal="full"
      >
        {title}
      </h1>
    </section>
  );
}
